<template>
  <v-card class="pa-2" :class="{ 'error-scroller': error }">
    <v-layout class="envio-sms-mensagens pt-0">
      <v-flex class="pr-2" xs6>
        <v-card class="message-card elevation-0">
          <v-card-text>
            <v-layout>
              <p class="ml-2 title">
                {{ $t('campanhas.mensagem') }}
              </p>
              <v-spacer />
              <tooltip align="right" :disabled="!isIndustryCampaign" :message="tooltipMessage">
                <template-message-modal
                  v-model="selectedTemplate"
                  :disabled="disabled"
                  :mode="['SMS']"
                  :is-industry-campaign="isIndustryCampaign"
                  :tooltip-message="tooltipMessage"
                />
              </tooltip>
              <tooltip align="right" :disabled="!isIndustryCampaign" :message="tooltipMessage">
                <message-variables is-sms :disabled="disabled" :is-industry-campaign="isIndustryCampaign" :tooltip-message="tooltipMessage" />
              </tooltip>
            </v-layout>
            <v-tooltip top :disabled="!disabled">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-textarea
                    v-model="textLocal"
                    class="message-textarea primary-text"
                    :class="smsUsed == 1 && 'error-text-gray'"
                    spellcheck="false"
                    outlined
                    auto-grow
                    rows="8"
                    hide-details
                    data-cy="messageField"
                    :disabled="disabled"
                    :error="error"
                  />
                </div>
              </template>
              <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
              <span v-else-if="isIndustryCampaign">{{ tooltipMessage }}</span>
              <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
            </v-tooltip>
            <v-layout class="input-details">
              <span class="left-text" :class="smsUsed >= 2 ? 'error--text' : ''">{{ $tc('campanhas.creditos', smsUsed, { creditos: smsUsed }) }}</span>
              <v-spacer />
              <span class="right-text" :class="smsUsed >= 2 ? 'error--text' : ''">{{ charsUsed }} / {{ charsAvailable }}</span>
            </v-layout>
            <v-layout class="my-2 d-flex align-center">
              <mf-icon small>info</mf-icon>
              <span class="mf-caption primary-text mx-1"
                >{{ $t('campanhas.message_help_text') }}
                <span v-if="moreInfo" class="mf-caption primary-text more-info-text" @click="moreInfo = false">{{ $t('campanhas.menos') }}</span>
                <span v-else class="mf-caption primary-text more-info-text" @click="moreInfo = true">{{ $t('campanhas.mais') }}</span>
              </span>
            </v-layout>
            <v-layout v-if="moreInfo" class="more-info px-3 pt-3" wrap>
              <p class="mf-caption primary-text">
                {{ $t('campanhas.mais_informacoes_1') }}
              </p>
              <p class="mf-caption primary-text">
                {{ $t('campanhas.mais_informacoes_2') }}
              </p>
              <p class="mf-caption primary-text">
                {{ $t('campanhas.mais_informacoes_3') }}
              </p>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex class="pr-2" xs6>
        <v-card class="message-card elevation-0">
          <v-card-text>
            <p class="ml-2 title">
              {{ $t('campanhas.inspecao') }}
            </p>
            <div v-if="isMariaCampaign" class="inspect-box">
              <span
                v-for="(char, index) in textLocalWithVariable"
                :key="index"
                :class="{
                  'variable-container': isInsideInterval(index),
                  'variable-container-border-right':
                    isVariableBracket(char) && char === ']' && getSubvariableIndexesInterval().find((el) => el.includes(index)),
                }"
              >
                <v-chip
                  label
                  class="char-label primary-text"
                  :class="[
                    isSpecialChar(char) ? 'special' : '',
                    isSubvariable(char, index) ? 'subvariable' : '',
                    isVariable(char) || (isInsideInterval(index) && isVariableBracket(char)) ? 'variable' : '',
                    isSpace(char) ? 'space' : '',
                  ]"
                  >{{ char }}</v-chip
                >
              </span>
            </div>
            <div v-else class="inspect-box">
              <v-chip
                v-for="(char, index) in textLocalWithVariable"
                :key="index"
                label
                class="char-label primary-text"
                :class="[isSpecialChar(char) ? 'special' : '', isVariable(char) ? 'variable' : '', isSpace(char) ? 'space' : '']"
              >
                {{ char }}
              </v-chip>
            </div>
            <v-layout class="mt-4" fluid wrap>
              <v-flex class="my-2">
                <div class="mx-2 char-label example-char" />
                <span class="mf-caption">{{ $t('campanhas.caractere') }}</span>
              </v-flex>
              <v-flex class="my-2">
                <div class="mx-2 char-label example-char special" />
                <span class="mf-caption">{{ $t('campanhas.caractere_especial') }}</span>
              </v-flex>
              <v-flex class="my-2">
                <div class="mx-2 char-label example-char space" />
                <span class="mf-caption">{{ $t('campanhas.espaco') }}</span>
              </v-flex>
              <v-flex class="my-2">
                <div class="mx-2 char-label example-char variable" />
                <span class="mf-caption">{{ $tc('campanhas.variaveis', 1) }}</span>
              </v-flex>
              <v-flex v-if="isMariaCampaign" class="my-2">
                <div class="mx-2 char-label example-char subvariable" />
                <span class="mf-caption">{{ $tc('campanhas.subvariaveis', 1) }}</span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <p v-if="error" class="error-text">
      {{ errorMessage }}
    </p>
  </v-card>
</template>

<script>
import { charset7bit } from '@/config/charsets.js'
import { characterVariables } from '@/mixins/character-variables'
import { mapState } from 'vuex'
import TemplateMessageModal from '@/components/template-message/TemplateMessageModal.vue'

export default {
  components: {
    MessageVariables: () => import('@/modules/campanhas/views/components/edit/MessageVariables.vue'),
    Tooltip: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'),
    TemplateMessageModal,
  },
  mixins: [characterVariables],
  props: {
    value: String,
    error: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignActivated: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignFinished: {
      type: Boolean,
      default: false,
    },
    templateId: {
      type: String,
    },
    offerType: {
      type: String,
      default: 'general',
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    selectedTemplate: {},
    localSmsCostMessage: 1,
    moreInfo: false,
    charsAvailable: 0,
    charactersQuantity: 160,
    charactersValue: 153,
    specialCharactersQuantity: 70,
    specialCharacterValue: 67,
    isSms: true,
  }),
  computed: {
    ...mapState(['smsCostMessage']),
    disabledFieldTooltip() {
      const status = this.isMariaCampaignFinished ? 'concluída' : 'ativa'
      return `Não é possível alterar essa configuração em uma campanha ${status}.`
    },
    textLocalWithVariable() {
      return this.messageWithVariable(this.textLocal, true)
    },
    errorMessage() {
      if (this.error) return this.$t('campanhas.crie_mensagem')
      return ''
    },
    smsUsed: {
      get() {
        return this.localSmsCostMessage
      },
      set(value) {
        this.localSmsCostMessage = value
        this.$store.commit('smsCostMessage', value)
      },
    },
    showTooltip() {
      if (this.isMariaCampaignActivated || this.isMariaCampaignFinished || this.isIndustryCampaign) return true
      return this.disabled
    },
  },
  watch: {
    smsCostMessage() {
      if (this.smsCostMessage !== this.localSmsCostMessage) this.localSmsCostMessage = this.smsCostMessage
    },
    value() {
      this.updateCharsUsedLength(this.isSms)
    },
    selectedTemplate() {
      this.$emit('update:template-id', this.selectedTemplate._id)
      this.textLocal = this.selectedTemplate.message
    },
  },
  mounted() {
    this.updateCharsUsedLength(this.isSms)
  },
  methods: {
    isVariableBracket(char) {
      return this.isSpecialChar(char) && char === ']'
    },
    isSpecialChar(char) {
      if (charset7bit.indexOf(char) >= 0) return false
      return true
    },
    isVariable(char) {
      if (this.insideVariables.includes(char)) return false
      const variaveis = this.smsVariables.map((object) => object.clipboardText)
      return Boolean(variaveis.includes(char))
    },
    isSubvariable(char, index) {
      const offer = this.offerType === 'combo' ? 'combo' : 'produto'
      const insideVariables = this.insideVariables.includes(char)
      const isBetterProduct = [`[primeiro melhor ${offer} `, `[segundo melhor ${offer} `, `[terceiro melhor ${offer} `].includes(char)
      if (!insideVariables) return
      return this.isInsideInterval(index) && !isBetterProduct
    },
    getSubvariableIndexesInterval() {
      const indexes = []
      const indexesStart = []
      const offer = this.offerType === 'combo' ? 'combo' : 'produto'
      this.textLocalWithVariable.forEach((char, index) => {
        if ([`[primeiro melhor ${offer} `, `[segundo melhor ${offer} `, `[terceiro melhor ${offer} `].includes(char)) {
          indexesStart.push(index)
        }
      })
      indexesStart.forEach((indexStart) => {
        if (indexStart < 0) {
          indexes.push([-1, -1])
        } else {
          indexes.push([
            indexStart,
            this.textLocalWithVariable.findIndex((char, index) => {
              return char === ']' && index > indexStart
            }),
          ])
        }
      })
      return indexes
    },
    isSpace(char) {
      return Boolean(char === ' ')
    },
    isInsideInterval(index) {
      const indexes = this.getSubvariableIndexesInterval()
      return indexes.find(([start, final]) => final > -1 && index >= start && index <= final)
    },
    handleSuccess(e) {
      this.$snackbar({ message: 'Copiado para área de transferencia', snackbarColor: 'info' })
    },
    resetSmsVariables() {
      this.charsAvailable = 0
      this.smsUsed = 1
    },
    countCharsAvailable(coding) {
      this.resetSmsVariables()

      if (coding === '7bit') {
        if (this.charsUsed > this.charactersQuantity) {
          this.smsUsed = Math.ceil(this.charsUsed / this.charactersValue)
          this.charsAvailable = this.charactersValue
        } else {
          this.charsAvailable = this.charactersQuantity
        }
      } else {
        if (this.charsUsed > this.specialCharactersQuantity) {
          this.smsUsed = Math.ceil(this.charsUsed / this.specialCharacterValue)
          this.charsAvailable = this.specialCharacterValue
        } else {
          this.charsAvailable = this.specialCharactersQuantity
        }
      }
    },
  },
}
</script>

<style lang="scss">
.error-text {
  color: #ff5252 !important;
  font-size: 12px;
  padding: 0 12px;
  margin: 0;
}
.envio-sms-mensagens {
  .example-message {
    background-color: $cinza-l90;
    border-radius: 4px;
  }
  .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    font-family: 'Roboto Mono', monospace;
    line-height: 32px;
    margin-top: 8px;
  }
  .message-textarea {
    .v-input__slot {
      background-color: $branco !important;
      border-color: $cinza-l10 !important;
    }
  }

  .input-details {
    font-size: 12px;
    padding-left: 12px 4px;
    color: rgba(0, 0, 0, 0.54);
  }

  .char-label {
    border: 1px solid #a9e34b;
    font-weight: bold;
    font-family: 'Roboto Mono', monospace;
    font-size: 12px;
    user-select: none;
    background-color: $branco;
    margin: 1px;
    padding-left: 2px;
    padding-right: 2px;
    letter-spacing: 2px;
    border-radius: 2px;
    max-height: 24px;
    min-width: 18px;
    .v-chip__content {
      width: 100%;
      padding: 0;
      justify-content: center;
    }
  }
  .special {
    border: 1px solid #ff922a !important;
    background-color: #ffc078 !important;
  }
  .variable {
    border: 1px solid #9775fa !important;
    background-color: #d0bfff !important;
  }
  .subvariable {
    border: 1px solid #f679d3 !important;
    background-color: #fbc0e3 !important;
  }
  .space {
    border: 1px solid #82c91e !important;
    background-color: #d8f5a2 !important;
  }
  .variable-container {
    display: inline-block;
    padding: 2px;
    margin: 2px 0px;
    border: 1px solid #9775fa;
    background-color: #d0bfff !important;
    border-left-color: transparent;
    border-right-color: transparent;
  }
  .variable-container-border-right {
    border-right-color: #9775fa !important;
  }
  .message-card {
    min-height: 320px !important;
    background-color: $cinza-l90;
  }
  .inspect-box {
    background-color: $branco;
    border: 2px solid rgba(0, 0, 0, 0.24);
    border-radius: 3px;
    padding: 15px 12px 12px;
    min-height: 204px;
  }
  .example-char {
    padding: 0 6px;
    width: 4px;
    display: inline;
  }
  .more-info {
    background-color: $cinza-l90;
    border-radius: 4px;
  }
  .more-info-text {
    text-decoration: underline;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .error-text-gray {
    .v-messages__message {
      color: $cinza-l20 !important;
    }
  }
}
.variable-highlight-color {
  background-color: #c0eb75;
  cursor: pointer;
}
</style>
